import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import './CreateBlueprint.css';
import { Col, Label, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faArrowLeft, faCircle, faCog, faKeyboard, faList, faLock, faPen, faPlus, faProjectDiagram, faTimes, faTrashAlt, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { ArrowLeftOutlined, CloseOutlined, LockOutlined, MinusCircleOutlined, PlusCircleOutlined, PlusOutlined, RightOutlined, UnlockOutlined } from '@ant-design/icons';
import { Dropdown as AntDropdown, Button, Input, Tabs, Divider, Switch, Typography, Radio, Select, Popover, Modal, Badge, Timeline, TimePicker} from 'antd';
import { Flow } from './Flow';
import TextArea from 'antd/es/input/TextArea';
import { CompactPicker } from 'react-color';
import { HexColorRenges, invertColor } from '../HR/TimeClock/Util';
import { CustomColorPicker } from '../CustomColorPicker/CustomColorPicker';
import AwsServerService from '../../common/util/AwsServerService';
import { AllDeals, EnableFlow, Socket, TaskFlowEditCount } from '../../Context/AppActions';
import AppContext from '../../Context/AppContext';
import CustomMultiSelect from '../../common/custom_multiselect/custom_multiselect';
import { AppDataRequired } from '../../App';
import { CriteriaModal } from './HelperComponents/CriteriaModal';
import swal from "sweetalert";
import { filterEdges } from '../../Util/CommonUtil';
import { InputFields } from '../InputFields/InputFields';
import { NewCustomePopover } from './HelperComponents/NewCustomePopover';
import LeftBottom from '../../assets/images/svg/Left-Bottom.svg';
import BottomRight from '../../assets/images/svg/Bottom-Right.svg';
import BottomLeft from '../../assets/images/svg/Bottom-Left.svg';
import TopLeft from '../../assets/images/svg/Top-Left.svg';
import RightTop from '../../assets/images/svg/Right-Top.svg';
import RightBottom from '../../assets/images/svg/Right-Bottom.svg';
import LeftRight from '../../assets/images/svg/Left-Right.svg';
import LeftTop from '../../assets/images/svg/Left-Top.svg';
import TopBottom from '../../assets/images/svg/Top-Bottom.svg';
import RightLeft from '../../assets/images/svg/Right-Left.svg';
import BottomTop from '../../assets/images/svg/Bottom-Top.svg';
import TopRight from '../../assets/images/svg/Top-Right.svg';
import { FaCodeBranch, FaExpandAlt } from 'react-icons/fa';
import { TaskFlowReminder } from './Reminder/TaskFlowReminder';
import EmailTemplates from './EmailTemplates';
import AfterFieldUpdate from './AfterFieldUpdate';
import ConditionTree from './Criteria/TreeNode';
import _ from 'lodash';
import { InputFieldIcon } from '../InputFields/IconPack';
import AccessControl from './AccessControl';
import { useDispatch, useSelector } from "react-redux"; 
import { setEnableFlow, setTaskFlowEditCount } from '../../Context/ReduxContext';
// import { Radio } from 'antd';
// import Select from 'react-select';
export const FlowContext = createContext();
const { TabPane } = Tabs;
const { Title, Text } = Typography;
const { Option } = Select;
const RaditOptionsForNode = [
  // { label: 'Both', value: 'Both' },
  { label: 'Open', value: 'Open' },
  { label: 'Closed', value: 'Close' },
  // { label: 'Orange', value: 'Orange', title: 'Orange' },
];

export const CreateBlueprint = ({setReloadFlow,reloadFlow, close, save ,editFlow,setEditFlow,view, allUsers, allUserRoles, allBlueprintData}) => {
    const reduxDispatch = useDispatch();
    const AppData = useContext(AppContext);
    const { dispatch ,state} = AppData || {};
    const [flowContext,setFlowContext] = useState({
      nodes:[],
      edges:[]
    })  
    const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals);
    const EnableFlow = useSelector((state) => state.AppReduxContext.EnableFlow);
    const TaskFlowEditCount = useSelector((state) => state.AppReduxContext.TaskFlowEditCount);
    const [errorPopConfirmForInput,setErrorPopConfirmForInput] = useState({Active:false,data:{},shouldDelete:false,field:'',Message:"",From:""});
    const [changesCount,setChangesCount] = useState(0);
    const [flowDirection,setFlowDirection] = useState(true);
    const { DealFields } = useContext(AppDataRequired);
    const [reminders,setReminders] = useState([])
    const [cacheReminders,setCacheReminders] = useState([])
    const [addNodeState, setAddNodeState] = useState();
    const [errorPopConfirm,setErrorPopConfirm] = useState();
    const [criteriaDeleteConfirm,setCriteriaDeleteConfirm] = useState();
    const [rowData,setRowData] = useState([]);
    const [allRoles,setAllRoles] = useState([])
    const [cacheRowData,setCacheRowData] = useState([]);
    const [dealHeaders,setDealHeaders] = useState([]);
    const [allCriteriaFields,setAllCriteriaFields] = useState({});
    const [selectInputField,setSelectInputField] = useState();
    const [criteriaFieldGroups,setCriteriaFieldGroups]=useState({}); 
    
    // const [DealFields,setDealFields] = useState();
  const fetRoles = () => {
    AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
      setAllRoles(res.data);
      // setAllCacheRoles(res.data);
    }).catch(err => {
      console.log(err);
    })
  }
    useEffect(e=>{
      setRowData(AllDeals?AllDeals:[])
      setCacheRowData(AllDeals?AllDeals:[]) 
    },[AllDeals])
    const fetchReminders = ({ROWID}) => {
      if(ROWID){
        AwsServerService.CrudServiceHandler({ method: "GETWHERE", data: {TaskFlowId:ROWID}, route: "TASKFLOWREMINDER" }).then(res => {
          setReminders(res.data);
          setCacheReminders(res.data);
          // setAllCacheRoles(res.data);
        }).catch(err => {
          console.log(err);
        })
      }
    }
    useEffect(e=>{
      if(editFlow?.ROWID){
        fetchReminders({ROWID:editFlow.ROWID});
      }
    },[editFlow])
    const getCriteriaFields=async()=>{
      await AwsServerService.getCriteriaFields().then(res=>{
        let obj={};
        if(res?.data){
          res.data.forEach(one=>{
            if(obj[one.module]){
              obj[one.module]=[...obj[one.module],one];
            }else{
              obj[one.module]=[one];
            }
          })
        }
        setAllCriteriaFields(obj);
      })
    }
    const [emailTransitionData,setEmailTransitionData]=useState([]);
     useEffect(()=>{
      if(editFlow?.ROWID){
        AwsServerService.getTransitionEmailByIdParam(editFlow?.ROWID).then(res=>{
          let resArray = res?.data;
          setEmailTransitionData(resArray);
        }) 
      }
      },[editFlow])
     function popupErrorForInputField() {
       return <NewCustomePopover
           width={30}
          open={errorPopConfirmForInput.Active}
          title={"Warning!"}
          okText={"Confirm"}
          cancelText={"Cancel"}
          onCancel={e => {
            setErrorPopConfirmForInput({Active:false,data:{},shouldDelete:false,field:'',Message:'',From:""})
          }}
          onOk={e => {
            
            if(errorPopConfirmForInput?.From=="Bot"){
            let temp={...bluePrintData};
            temp["BotAccountEmail"]=errorPopConfirmForInput?.data;
            setErrorPopConfirmForInput({Active:false,data:{},shouldDelete:false,field:'',Message:'',From:""})
            setBluePrintData(temp);
            setError(error?.filter((e) => e != "BotAccountEmail"))
            }else{ 
            let temp={...bluePrintData};
            let field=errorPopConfirmForInput?.field;
            temp["inputFields"]=temp?.inputFields?.filter(c=>c.id!=field.id);
            if(criteriaFieldGroups["Input Fields"]?.length>0){
              let tempCriteria = criteriaFieldGroups["Input Fields"]?.filter(k=>k.id!=field.id);
              setCriteriaFieldGroups({...criteriaFieldGroups,"Input Fields":tempCriteria});
            }
            setErrorPopConfirmForInput({...errorPopConfirmForInput,Active:false,shouldDelete:true,field:'',Message:'',From:""})
            setBluePrintData(temp);
          }
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <div className='Msg-Block' style={{flexDirection: 'column'}}>
             {errorPopConfirmForInput?.Message}
             <div>
            {errorPopConfirmForInput?.From==""?Object.keys(errorPopConfirmForInput.data)?.filter(el=>el)?.map(rec=>emailTransitionData?.find(r=>r.ROWID==rec)?.TransitionEdgeId)?.map((er,index)=>{
              let data=editFlow?.Edges?.find(e=>e.id==er);
              return <div className='internal' style={{display:'flex',padding:'3px'}}>
                      <span style={{marginRight:'3px'}}>{(index+1)+". "}</span>
                       <div className='internal2' style={{borderRadius:'4px',padding: '0px 4px 0px 4px',backgroundColor: data?.data?.color ? data?.data?.color : "#fff5e0",
                                     color: data?.data?.color ? invertColor(data?.data?.color, true) : "black"}}>
                        {data?.label}</div>
                     </div>
              }):""}
              </div>
          </div>
        </NewCustomePopover>
     }
     const getPopupIfRequired = (field) =>{
      let obj={};
      emailTransitionData?.forEach(rec=>{
        rec?.Attachments?.forEach(el=>{
          if(el?.id==field?.id){
            obj[rec?.ROWID]=rec?.Attachments?.filter(e=>e.id!=field.id);
          }
        })
      })
      if(!_.isEmpty(obj)){ 
        let msg="Field is in use for below transitions for Email Automation, Confirm deletion?"
        setErrorPopConfirmForInput({Active:true,data:obj,shouldDelete:false,field:field,Message:msg,From:""});
      }
     }
    useEffect(e=>{
      fetRoles();
      getCriteriaFields()
    },[])
    let nodeTemplate = {
        data: { label: 'Step 1' },
        id: "",
        position: { x: 703.7616611847143, y: 167.5149118380199 },
        positionAbsolute: { x: 703.7616611847143, y: 167.5149118380199 },
        description: "",
        type: "custom",
    }
    const [optionsForDropdown, setOptionsForDropdown] = useState({users:[],roles:[]});
    const { Option, OptGroup } = Select;
    const [selectedData, onSelectedData] = useState({
        type: "",
        data: null,
        action: "edit"
    });
    const [bluePrintData, setBluePrintData] = useState({
        name: "",
        description: "",
        inputFields:[],
        lock:'false',
        BotAccountEmail:""
    });
    useEffect(e=>{
      if(allCriteriaFields){
        let obj={...allCriteriaFields};
        if(bluePrintData && bluePrintData.inputFields?.length>0){
          bluePrintData.inputFields.forEach(i=>{
            if(obj["Input Fields"]){
              obj["Input Fields"]=[...obj["Input Fields"],i];
            }else{
              obj["Input Fields"]=[i];
            }
          })
        }
        if(state.FlowEdgeAndNodes?.edges?.length>0){
          state.FlowEdgeAndNodes.edges.forEach(i=>{
            if(i.label){
              if(obj["Transitions"]){
                obj["Transitions"]=[...obj["Transitions"],{label:i.label,field:i.id,type:"TRANSITION"}];
              }else{
                obj["Transitions"]=[{label:i.label,field:i.id,type:"TRANSITION"}];
              }
            }
          })
        }
        setCriteriaFieldGroups(obj);
      }
    },[bluePrintData,allCriteriaFields])
    const [error,setError]=useState([]);
    /////  new changes Nagesh Altekar /////
    const [selectedOption, setSelectedOption] = useState('Field');
    const [fieldValue, setFieldValue] = useState('');
    const [messageValue, setMessageValue] = useState('');
    const [radioValue, setRadioValue] = useState('fields');
    const [criteriaModal, setCriteriaModal] = useState(false);
    const [rows, setRows] = useState([{ id: Date.now() }]);




    
  const handleRadioChange = e => {
    setRadioValue(e.target.value);
  };
  
  // useEffect(()=>{
  //   const rejectSourceIds = new Set(editFlow?.Edges.filter(edge => edge.sourceHandle === 'reject').map(edge => edge.source)); 
  //   const filteredNodes = editFlow?.Nodes.filter(node => rejectSourceIds.has(node.id));
  //   setFiltedNode(filteredNodes)
  // },[editFlow])
  // useEffect(()=>{

  // },[DealFields])
  useEffect(()=>{
    if(selectedData?.type=="edge"){
      //  
      // console.log(selectedData?.data);
      if(editFlow?.Edges){
        // const edgesForCriteria = filterEdges(editFlow.Edges,selectedData.data)?.map(edge => ({
        //   ROWID:edge.id,
        //   label:edge.label,
        //   field:edge.id,
        //   module:"Transition",
        //   type:"transition",
        // })); 
        // // const filteredNodes = editFlow?.Nodes.filter(node => rejectSourceIds.has(node.id));
        // // setFiltedNode(filteredNodes);
        // if(edgesForCriteria?.length>0){
        //   setCriteriaFieldGroups({...criteriaFieldGroups,Transition:edgesForCriteria})
        // }
        // setEdgeOptionsForCriteria(edgesForCriteria)
      }
      
    }
  },[selectedData])
  const [nameError, setNameError] = useState(false);

const handleNameChange = (e) => {
  const input = e.currentTarget.value.trimStart();
  let obj = { ...bluePrintData };
  obj["name"] = input;

  const isDuplicate = allBlueprintData?.some(
    (item) =>
      item?.Name?.toLowerCase().trim() === input.toLowerCase().trim() &&
      item?.ROWID !== editFlow?.ROWID // same ID allowed in edit mode
  );

  setNameError(isDuplicate); // true if duplicate
  setBluePrintData(obj);
};
  function handleChangeCriteria(option,type,index) {
    let obj=[...rows]; 
    if(obj[index]){
      obj[index][type]=option; 
    }else{
      obj[index]={[type]:option}
    }
    setRows(obj)
  }
  const handleSaveCriteria=()=>{
    
  } 

  useEffect(()=>{
    if(allUsers && allUsers.length>0){
     let userArray = allUsers.map(e=>{ 
        return {value:e.full_name,label:e.full_name,zuid:e.zuid,status:e.status,role:e.role.name}
      })
      setOptionsForDropdown(user => ({...user,users: userArray}));
    }
    if(allUserRoles && allUserRoles.length>0){
      let rolesArray = allUserRoles.map(e=>{ 
        return {value:e.name,label:e.name,id:e.id}
      })
      setOptionsForDropdown(role => ({...role,roles: rolesArray}));
    }
  },[allUsers,allUserRoles])
  const handleChange = (value) => {
    console.log('Selected values: ', value);
  };
  
  const getCriteriaRows = useCallback(criteria=>{
    if(criteria && criteria.length>0){
      // return <div style={{cursor:"pointer"}} onClick={e=>{
      //   setCriteriaModal(true)
      // }} className='Criteria-Preview-container'>
      //    {/* <div className='Criteria-Overlay'>
      //     <Button style={{"box-shadow": "0px 0px 7px #818181",cursor:"pointer"}} onClick={e=>{
      //       setCriteriaModal(true)
      //     }} icon={<FaExpandAlt/>}>Expand</Button>
      //    </div> */}
      //   <Timeline className='Timeline-Custom-Class'>
      //     {criteria.map((c,i)=>{
      //       console.log("criteria", c)
      //       return <Timeline.Item className='Custom-Dot' dot={<span className={`Timeline-Custom-Dot ${c.condition}`}>{c.condition}</span>}>
      //         <div style={{color:"#5a6c97"}}>
      //           <span className="m-1 p-1 fw-bold">
      //             <strong>Type: </strong>{c.group}
      //           </span>
      //           <span className="m-1">
      //             <FontAwesomeIcon icon={faAngleRight}/>
      //           </span>
      //           <span className="m-1 p-1 fw-bold">
      //           <strong>Field Name: </strong>{criteriaFieldGroups[c.group]?.find(k=>k.value==c.value)[(c.group=="Input Fields"?"Name":"label")]}
      //           </span>
      //         </div>
      //       </Timeline.Item>
      //     })}
          
      //   </Timeline>
      // </div> 

      return <>
        <ConditionTree allRoles={allRoles} criteriaFieldGroups={criteriaFieldGroups} criteria={criteria}/>
      </>
    }else{
      return <></>
    }
    // if (criteria && criteria.length > 0) {
    //   return (
    //     <div
    //       style={{ cursor: "pointer" }}
    //       onClick={(e) => {
    //         setCriteriaModal(true);
    //       }}
    //       className="Criteria-Preview-container"
    //     >
    //       <ul className="Criteria-List">
    //         {criteria.map((c, i) => {
    //           console.log("criteria", c);

    //           // Handle `c.last` for different types
    //           let formattedLast;
    //           if (typeof c.last === "object" && c.last instanceof Date) {
    //             formattedLast = dayjs(c.last).format("MM-DD-YYYY");
    //           } else if (typeof c.last === "boolean") {
    //             formattedLast = c.last ? "Yes" : "No";
    //           } else {
    //             formattedLast = c.last || "N/A";
    //           }

    //           return (
    //             <li key={i} className="Criteria-Item">
    //               The {(c.initial || "").replaceAll("_", " ")} {c.middel} {formattedLast}
    //             </li>
    //           );
    //         })}
    //   </ul>
    //     </div>
    //   );
    // } else {
    //   return <></>;
    // }
    
  },[selectedData])
console.log("data check" , bluePrintData);
  const getDescriptionPopover = (data) => {
    
    // Content for the popover, showing the form based on selected option
    const content = (
      <div>
        <Radio.Group 
          value={selectedOption} 
          onChange={(e) => setSelectedOption(e.target.value)}
          style={{ marginBottom: '10px' }}
        >
          <Radio value="Field">Field</Radio>
          <Radio value="Message">Message</Radio>
        </Radio.Group>
  
        {selectedOption === 'Field' ? (
          <Select
            placeholder="Select"
            value={fieldValue}
            onChange={(value) => setFieldValue(value)}
            style={{ width: '100%', marginBottom: '10px' }}
          >
            <Option value="field1">Field 1</Option>
            <Option value="field2">Field 2</Option>
          </Select>
        ) : (
          <TextArea
            placeholder="Enter message"
            value={messageValue}
            onChange={(e) => setMessageValue(e.target.value)}
            maxLength={100}
            rows={1}
            style={{ marginBottom: '10px' }}
          />
        )}
  
        <Button type="primary" onClick={() => console.log('Add button clicked')}>Add</Button>
        <Button style={{ marginLeft: '10px' }} onClick={() => console.log('Cancel button clicked')}>Cancel</Button>
      </div>
    );
  
    return (
      <Popover content={content} title="" trigger="click" rootClassName="Blueprint-Field-Popover">
        <Button type="link" style={bluePrintData?.lock=="true" ? {pointerEvents: "none", opacity: 0.5, cursor: "not-allowed", marginLeft: '10px'} :{ marginLeft: '10px' }}>+ Add</Button>
      </Popover>
    );
  };

  const handleAddRow = () => {
    setRows([...rows, { id: Date.now() }]); // Add new row with unique id
  };

  const handleRemoveRow = (id,keyToRemove) => {
    const updatedRows = rows.filter((row) => row.id !== id);
    setRows(updatedRows);
    // setCriteriaDetails((prevDetails) => { 
    //   const newDetails = Object.keys(prevDetails)
    //     .filter((key) => key !== String(keyToRemove))
    //     .reduce((acc, key, index) => { 
    //       acc[index] = prevDetails[key];
    //       return acc;
    //     }, {}); 
    //   return newDetails;
    // });
  
  };
  
  // const setActiveFilterAndGetActiveFilters = async (
  //   filters,
  //   action,
  //   mainFilters
  // ) => {
  //   let api = gridApi;
  //   if (action == "SAVE") {
  //     if (api) {
  //       let filtersModal = await api.getFilterModel();
  //       return filtersModal;
  //     }
  //   } else if (action == "SET") {
  //     let filterMain = mainFilters;
  //     if (!_.isArray(mainFilters) && !_.isEmpty(mainFilters)) {
  //       do {
  //         filterMain = JSON.parse(filterMain);
  //       } while (!_.isArray(filterMain));
  //     }
  //     let filter = filters;
  //     if (!_.isObject(filters) && !_.isEmpty(filters)) {
  //       do {
  //         filter = JSON.parse(filter);
  //       } while (!_.isObject(filter));
  //     }
  //     setPreAppliedFiltersForView(filterMain);
  //     setTimeout(() => {
  //       setActiveFiltersOnColumnLevel(filter);
  //     }, 1000);
  //   }
  // };
  const [filtersmode, setfiltersmode] = useState([]);
  const [AllDealsClicked, setAllDealsClicked] = useState(false);
  const [dealStatus, setDealStatus] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [filterItemsDeal, setFilterItemsDeal] = useState([
    { name: "Deal Name", type: "string" },
    { name: "Accounts", type: "string" },
    { name: "Status", type: "string" },
    { name: "Borough", type: "string" },
    { name: "Closing Date", type: "date" },
    { name: "Created By", type: "string" },
  ]);
  useEffect(() => {
    if (DealFields.length > 0) {
      let arr = [];
      const items = [...DealFields];

      items.forEach((one) => {
        // if (!hideArray.includes(one.field) && !(
        //   pvSystemTableHeaders.find(e => e.value == one.field)
        //   || wwwViolationHeaders.find(e => e.value == one.field)
        //   || previousSolarAppHeaders.find(e => e.value == one.field)
        // )) {
          if (one.type == "text") {
            one.field == "Occupancy_Classification_Building_2014_2008_Code" ?
              arr.push({ name: one.name, type: "boolean", api_name: one.field }) :
              arr.push({ name: one.name, type: "string", api_name: one.field });
          } else if (one.type == "integer") {
            arr.push({ name: one.name, type: "number", api_name: one.field });
          } else if (one.type == "date") {
            arr.push({ name: one.name, type: "date", api_name: one.field });
          } else if (one.type == "picklist") {
            one.field == "Owner_Type" || one.field == "Active_Work_Without_Permit_Violations"
              || one.field == "Occupancy_Classification_of_Building" ?
              arr.push({ name: one.name, type: "string", api_name: one.field }) :
              arr.push({ name: one.name, type: "boolean", api_name: one.field });
          } else if (one.type == "formula") {
            arr.push({ name: one.name, type: "number", api_name: one.field });
          } else if (one.type == "currency") {
            arr.push({ name: one.name, type: "number", api_name: one.field });
          } else {
            arr.push({ name: one.name, type: "string", api_name: one.field });
          }
        // }
      });
      setDealHeaders(arr);
    }
  }, [DealFields]);

    /////  new changes Nagesh Altekar /////

    const validation=(data)=>{ 
        let temp=[];
        Object.keys(data).forEach(key=>{
          if(!data[key]){
            temp.push(key)
          }
        })
        setError(temp);
        return temp.length==0;
    }
    useEffect(e=>{
        if(editFlow){
            //  
            // setChangesCount(0);
            reduxDispatch(setTaskFlowEditCount(0));
            let {Name,Description,LockFlow,InputFields,BotAccountEmail} = {...editFlow};
            setBluePrintData({
                name:Name,
                description:Description,
                lock:LockFlow,
                inputFields:InputFields,
                BotAccountEmail:BotAccountEmail
            })
            onSelectedData({
                type:"edit flow",
                action:"",
                data:{...editFlow}
            })

            // setEditFlow(null);
        }
    },[editFlow])
    // console.log("selectedData?.type", selectedData);
useEffect(()=>{
  const handleBeforeUnload  = (e)=>{
    const isUpdateEnabled = view === "edit" && (TaskFlowEditCount > 0 || editFlow?.BotAccountEmail !==bluePrintData?.BotAccountEmail)

    if(isUpdateEnabled){
      e.preventDefault();
      e.returnValue = " ";
    }
  }
  window.addEventListener('beforeunload', handleBeforeUnload);
  return ()=>{
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
},[TaskFlowEditCount, editFlow?.BotAccountEmail, bluePrintData?.BotAccountEmail])
    const saveReminders=({TaskFlowId,arr})=>{
      if(TaskFlowId){
        AwsServerService.CrudServiceHandler({ method: "DELETEBYCOLUMN", data:{key:"TaskFlowId",value:TaskFlowId}, route: "TASKFLOWREMINDER" }).then(res=>{
          Promise.all(arr.map(r=>AwsServerService.CrudServiceHandler({ method: "POST", data:{...r,TaskFlowId:TaskFlowId}, route: "TASKFLOWREMINDER" }))).then(res=>{
             
          }).catch(e=>{
            console.log(e);
          })
        }).catch(e=>{
          console.log(e);
        })
      }
    }
    const onDirectionClick=(e)=>{
      let direction=e.currentTarget.id;
      setAddNodeState({direction:direction});
    }
    const BotAccounts=[
      {
        value: 'aditya@srsolardesign.com',
        label: 'aditya@srsolardesign.com',
        key:0
      },
      {
        value: 'david@srsolardesign.com',
        label: 'david@srsolardesign.com',
        key:1
      },
      {
        value: 'permitting@srsolardesign.com',
        label: 'permitting@srsolardesign.com',
        key:2
      },
    ] 
    return (
      <div className="Create-Blueprint-Wrapper">
        {popupErrorForInputField()}
        <NewCustomePopover
          width={30}
          open={errorPopConfirm}
          title={"Warning!"}
          okText={"Confirm"}
          cancelText={"Cancel"}
          onCancel={e => {
            setErrorPopConfirm(null);
          }}
          onOk={e => {
            setErrorPopConfirm(null);
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <div className='Msg-Block'>
            {errorPopConfirm}
          </div>
        </NewCustomePopover>
        <NewCustomePopover
          width={30}
          open={criteriaDeleteConfirm}
          title={"Warning!"}
          okText={"Confirm"}
          cancelText={"Cancel"}
          onCancel={e => {
            setCriteriaDeleteConfirm(null);
          }}
          onOk={e => {
            let obj = { ...selectedData };
            obj["data"]["Criteria"] = [];
            onSelectedData(obj);
            setCriteriaDeleteConfirm(null);
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <div className='Msg-Block'>
            {criteriaDeleteConfirm}
          </div>
        </NewCustomePopover>
        {/* {<InputFields/>} */}
        {<CriteriaModal 
        mainFields={criteriaFieldGroups} 
        open={criteriaModal} 
        criteriaRows={selectedData?.data?.Criteria}
        action={view}
        setOpen={setCriteriaModal} 
        onSave={(data)=>{ 
          let obj = { ...selectedData };
          //const filteredData = data?.filter(item => item?.initial !== undefined);
          obj["data"]["Criteria"] = data;
          onSelectedData(obj);
        }}
        />}
        <div className="Blueprint-Header">
          <Row className="">
            <Col className="d-flex align-items-center" sm={6}>
              {/* <FontAwesomeIcon className='logo' icon={faProjectDiagram} /> */}
              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginLeft: "10px",
                  color: "#5b6c97",
                }}
              >
                <FontAwesomeIcon icon={<FaCodeBranch/>} /> {bluePrintData?.name}
              </span>
              <span style={{"margin-left": "24px"}}>
                <Switch
                  value={bluePrintData?.lock=="true"?true:false}
                  checkedChildren={<FontAwesomeIcon icon={faLock} color='#ffffff' />}
                  unCheckedChildren={<FontAwesomeIcon icon={faUnlock} color='#ffffff' />}
                  defaultChecked={false}
                  onChange={async e=>{
                    let temp = {
                      "ROWID": editFlow.ROWID,
                      "LockFlow": e+"",
                    }
                    await AwsServerService.updateTaskFlow(temp).then(res => {
                      dispatch(
                        Socket({ trigger: "Refresh_Module", data: "Task Flow" })
                      );
                    }).catch(err => {
                      console.log(err);
                    })
                    let obj = { ...bluePrintData };
                    obj["lock"] = e+"";
                    setBluePrintData(obj);
                  }}
                />
              </span>  
              {/* <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginLeft: "10px",
                  color: "#5b6c97",
                }}
              >{bluePrintData?.name}</span> */}
            </Col>
            {/* <Col sm={2}></Col> */}
            <Col sm={3} style={{maxWidth:"24%"}}></Col>
            <Col
              sm={3}
              style={{
                display: "flex",
                "align-items": "center",
                "justify-content": "space-evenly",
                maxWidth:"26%"
              }}
            >
              <Select
                showSearch
                style={{height:'auto',/*marginRight: '.3em',*/ display:"flex", marginRight: "10px", width: '13rem'}}
                rootClassName={error.includes('BotAccountEmail')?"selectBotClassName":"NoClass"}
                onSelect={(value,option)=>{
                  let obj = { ...bluePrintData };
                  if(obj["BotAccountEmail"] && editFlow?.BotAccountEmail!=value){
                    let msg="Changing the bot account may lead to loss of existing emails on tasks linked to this flow."
                    setErrorPopConfirmForInput({Active:true,shouldDelete:false,field:'',Message:msg,From:"Bot",data:value})
                  }else{
                    obj["BotAccountEmail"] = value;
                    setBluePrintData(obj);
                    setError(error?.filter((e) => e != "BotAccountEmail"))
                  }
                }} 
                value={bluePrintData?.BotAccountEmail}
                placeholder="Select Email Bot Account"
                optionFilterProp="label" 
                options={BotAccounts}
              />
              <TaskFlowReminder setReminders={(d)=>{
                setReminders(d);
              }} reminders={reminders} />
              {true && (
                <>
                  <Button
                    disabled={bluePrintData?.lock=="true" || (view == "edit" && TaskFlowEditCount == 0 && editFlow?.BotAccountEmail==bluePrintData?.BotAccountEmail)}
                    className="mr-1"
                    type="primary"
                    // icon={<FontAwesomeIcon className='opacity-75' color='red' icon={faTrashAlt} />}
                    onClick={() => {
                      if (validation({ ...bluePrintData })) {
                          onSelectedData({
                            type: "flow",
                            data: { ...bluePrintData },
                            action: view,
                          });
                      }else{
                        onSelectedData({
                          type: "",
                          data: "",
                          action: "",
                        });
                      }
                    }}
                  >
                    {view == "edit" ? "Update" : "Save"}
                  </Button>
                </>
              )}
              <Button
                icon={<FontAwesomeIcon className="opacity-75" icon={faTimes} />}
                onClick={() => {
                  onSelectedData({
                    type: "",
                    data: null,
                    action: "edit"
                  })
                  close();
                }}
              ></Button>
            </Col>
          </Row>
        </div>
        <Row className="Create-Blueprint-Body m-0">
          <Col style={{ position: "relative",height: "85vh" }} sm={8}>
            <div className='Flow-Button'>
              <span>Flow Directions:&nbsp;</span>
              <Switch 
                value={EnableFlow}
                checkedChildren={"On"}
                unCheckedChildren={"Off"}
                onChange={e=>{
                  reduxDispatch(setEnableFlow(e))
                }}
              />
            </div>
            <Button
            disabled={bluePrintData?.lock=="true"}
              type="primary"
              className="Add-Node-Button"
              icon={<FontAwesomeIcon className="opacity-75" icon={faPlus} />}
              onClick={() => {
                // setAddNodeState("add");
                setAddNodeState("add");
              }}
            >
              Add Status
            </Button>
            <Popover
              placement="bottom"
              trigger={"click"}
              overlayClassName='Add-Diverse-Popover'
              content={<>
                {/* <ul>
                  <li id={"top-bottom"} onClick={onDirectionClick}>Top-Bottom</li>
                  <li id={"bottom-top"} onClick={onDirectionClick}>Bottom-Top</li>
                  <li id={"left-bottom"} onClick={onDirectionClick}>left-bottom</li>
                  <li id={"left-right"} onClick={onDirectionClick}>left-right</li>
                  <li id={"left-top"} onClick={onDirectionClick}>left-top</li>
                </ul> */}
                <Row className='Direction-Wrapper Global-Text-Color' style={{fontWeight:"bold"}}>Select Direction</Row>
                <Row className='Direction-Wrapper'>
                  <img id="TopBottom" onClick={onDirectionClick} className="Direction-icons" src={TopBottom} alt="" />
                  <img id="RightLeft" onClick={onDirectionClick} className="Direction-icons" src={RightLeft} alt="" />
                  <img id="BottomTop" onClick={onDirectionClick} className="Direction-icons" src={BottomTop} alt="" />
                  <img id="LeftRight" onClick={onDirectionClick} className="Direction-icons" src={LeftRight} alt="" />
                  <img id="TopLeft" onClick={onDirectionClick} className="Direction-icons" src={TopLeft} alt="" />
                  <img id="TopRight" onClick={onDirectionClick} className="Direction-icons" src={TopRight} alt="" />
                  <img id="RightTop" onClick={onDirectionClick} className="Direction-icons" src={RightTop} alt="" />
                  <img id="RightBottom" onClick={onDirectionClick} className="Direction-icons" src={RightBottom} alt="" />
                  <img id="BottomRight" onClick={onDirectionClick} className="Direction-icons" src={BottomRight} alt="" />
                  <img id="BottomLeft" onClick={onDirectionClick} className="Direction-icons" src={BottomLeft} alt="" />
                  <img id="LeftTop" onClick={onDirectionClick} className="Direction-icons" src={LeftTop} alt="" />
                  <img id="LeftBottom" onClick={onDirectionClick} className="Direction-icons" src={LeftBottom} alt="" />
                </Row>
              </>}
            >

              <Button
                style={{top:"48px"}}
                disabled={bluePrintData?.lock=="true"}
                type="primary"
                className="Add-Node-Button"
                icon={<FontAwesomeIcon className="opacity-75" icon={faPlus} />}
                onClick={() => {
                  // setAddNodeState("add");
                  // setAddNodeState("addDiverseNode");
                }}
              >
                Add Waypoints
              </Button>
            </Popover>
            <Flow
              errorPopConfirmForInput={errorPopConfirmForInput}
              view={view}
              reminders={reminders}
              cacheReminders={cacheReminders}
              flowContext={flowContext}
              editFlow={editFlow}
              bluePrintData={bluePrintData}
              addNodeButton={addNodeState}
              resetAddNodeButton={setAddNodeState}
              selectedData={selectedData}
              onSelectedData={onSelectedData}
              onNodeSelect={(node) => {
                onSelectedData({
                  type: "node",
                  data: node,
                  action: "edit",
                });
              }}
              onEdgeSelected={(edge) => {
                onSelectedData({
                  type: "edge",
                  data: edge,
                  action: "edit",
                });
              }}
              saveCallback={({data,type}) => {debugger
                 
                if(editFlow?.ROWID){
                  saveReminders({TaskFlowId:editFlow.ROWID,arr:[...reminders]});
                }else{
                  saveReminders({TaskFlowId:data?.data[0]?.insertId,arr:[...reminders]});
                }
                dispatch(
                  Socket({ trigger: "Refresh_Module", data: "Task Flow" })
                );
                reduxDispatch(setTaskFlowEditCount(0));
                if(type=="create"){
                  setChangesCount(pre=>pre+1);
                  setBluePrintData({
                    name: "",
                    description: "",
                  });
                  close();
                }else if(type=="edit"){
                  setReloadFlow(!reloadFlow);
                }
              }}
            />
          </Col>
          <Col className="right-section" sm={4}>
            <Row
              style={{
                // "padding": "10px 0px",
                height: "3rem",
                border: "1px solid #e8e8e8",
                margin: "0px",
                "box-shadow": "0px 0px 5px -1px grey",
              }}
              className="mt-2 mb-2 d-flex align-items-center"
              sm={12}
            >
              <Col sm={9}>
                <span
                  style={{
                    "font-size": "1rem",
                    "font-weight": "600",
                    "margin-left": "10px",
                    color: "rgb(91, 108, 151)",
                  }}
                  className="fs-3"
                >
                  {!selectedData?.type ? (
                    "Task Flow"
                  ) : selectedData?.type == "node" ? (
                    "Edit Status"
                  ) : selectedData?.type == "edge" ? (
                    "Edit Transition"
                  ) : (
                    <></>
                  )}
                </span>
              </Col>
              <Col className="d-flex justify-content-end" sm={3}>
                {selectedData?.type && (
                  <>
                    <Button
                    disabled={bluePrintData?.lock=="true"}
                      className="mr-1"
                      icon={
                        <FontAwesomeIcon
                          className="opacity-75"
                          color="red"
                          icon={faTrashAlt}
                        />
                      }
                      onClick={() => {
                        let temp = { ...selectedData };
                        temp["action"] = "delete";
                        onSelectedData(temp);
                      }}
                    ></Button>
                    <Button
                      icon={
                        <FontAwesomeIcon
                          className="opacity-75"
                          icon={faArrowLeft}
                        />
                      }
                      onClick={() => {
                        onSelectedData({
                          type: "",
                          data: "",
                          action: "",
                        });
                      }}
                    ></Button>
                  </>
                )}
              </Col>
            </Row>
            {selectedData?.type == "node" ? (
              <>
                <Row className="Input-Group">
                  <Col className="d-flex p-0 m-0 align-items-center" sm={1}>
                    <CustomColorPicker
                      value={selectedData?.data?.data?.color}
                      onChange={(color) => {
                        let obj = { ...selectedData };
                        obj["data"]["data"]["color"] = color;
                        onSelectedData(obj);
                      }}
                    />
                  </Col>
                  <Col sm={11}>
                    <span className="labeltext">
                      <Label>Name</Label>
                    </span>
                    <Input
                       readOnly={bluePrintData?.lock == "true"}
                      className="input"
                      value={selectedData?.data?.data?.label}
                      onChange={(e) => {
                        e.currentTarget.value = e.currentTarget.value.trimStart();
                        let obj = { ...selectedData };
                        obj["data"]["data"]["label"] = e.currentTarget.value;
                        onSelectedData(obj);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="Input-Group">
                  <Col>
                    <span className="labeltext">
                      <Label>Description</Label>
                    </span>
                    <TextArea
                    disabled={bluePrintData?.lock=="true"}
                      value={selectedData?.data?.description}
                      style={{
                        padding: "5px 13px",
                        "min-height": "5rem",
                        "max-height": "5rem",
                      }}
                      onChange={(e) => {
                        e.currentTarget.value = e.currentTarget.value.trimStart();
                        let obj = { ...selectedData };
                        obj["data"]["description"] = e.currentTarget.value;
                        onSelectedData(obj);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="Input-Group">
                  <Col>
<Radio.Group
  disabled={bluePrintData?.lock=="true"}
  options={RaditOptionsForNode}
  onChange={({ target: { value } }) => {
  //   console.log("editFlow ID:", editFlow?.ROWID);
  //   console.log("allBlueprintData:", allBlueprintData);
  //     console.log("Selected node:", selectedData);
  // console.log("bluePrintData.Nodes:", bluePrintData?.Nodes);
  // console.log("flowContext.nodes:", flowContext?.nodes);

    if (value === "Close") {
      // const currentBlueprint = allBlueprintData?.find(
      //   bp => bp.ROWID === editFlow?.ROWID
      // );

      const otherClosedNode = editFlow?.Nodes?.find(
        node =>
          node.data?.state === "Close" &&
          node.id !== selectedData?.data?.id
      );

      if (otherClosedNode) {
        // ✅ Show which node is already closed
        swal({
          title: "Warning!",
       text: `Status "${otherClosedNode.data?.label}" is already a closing status, you can not mark another closing status.`,
          icon: "warning",
          button: "OK",
        });
        return; 
      }

      // Confirmation for closing current node
      swal({
        title: "Warning!",
        text: "You might lose the connected transitions. Want to proceed?",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "Proceed",
        },
      }).then((isTrue) => {
        if (isTrue) {
          let obj = { ...selectedData };
          obj["data"]["data"]["state"] = value;
          onSelectedData(obj);
        }
      });

    } else {
      // 🟢 Open state
      let obj = { ...selectedData };
      obj["data"]["data"]["state"] = value;
      onSelectedData(obj);
    }
  }}
  value={selectedData?.data?.data?.state ? selectedData.data.data.state : "Open"}
/>

                  </Col>
                </Row>
                
              </>
            ) : selectedData?.type == "edge" ? (
              <>
                <Row className="Input-Group">
                  <Col className="d-flex p-0 m-0 align-items-center" sm={1}>
                    <CustomColorPicker
                    disabled={bluePrintData?.lock=="true" || selectedData?.data?.uneditable}
                      value={selectedData?.data?.data?.color}
                      onChange={(color) => {
                        let obj = { ...selectedData };
                        if(obj["data"]["data"]){
                          obj["data"]["data"]["color"] = color;
                        }else{
                          obj["data"]["data"]={color:color};
                        }
                        onSelectedData(obj);
                      }}
                    />
                  </Col>
                  <Col sm={11}>
                    <span className="labeltext">
                      <Label>Label</Label>
                    </span>
                    <Input
                    readOnly={bluePrintData?.lock=="true" || selectedData?.data?.uneditable}
                      className="input"
                      value={selectedData?.data?.uneditable?"This is Waypoint transition" :selectedData?.data?.label}
                      onChange={(e) => {
                        e.currentTarget.value = e.currentTarget.value.trimStart();
                        let obj = { ...selectedData };
                        obj["data"]["label"] = e.currentTarget.value;
                        onSelectedData(obj);
                        
                      }}
                    />
                  </Col>
                </Row>
                <Row className="Trasition-Tabs">
                  <Col>
                    <div style={{ padding: "20px" }}>
                      <Divider />

                    {!selectedData?.data?.uneditable && <Tabs defaultActiveKey="1" centered>
                      <TabPane tab="Before" key="1">
                        <div>
                          <h5>Users</h5>
                          <p style={{marginBottom: "10px"}}>
                              Select individual users or roles to view and perform this transition.
                          </p>
                          <Select 
                          disabled={bluePrintData?.lock=="true"}
                            mode="multiple" 
                            style={{width: '25.5rem',height: 'auto'}}
                            placeholder="Select"
                            onChange={handleChange}
                          >
                          <OptGroup label="Roles">
                          {optionsForDropdown.roles?.map(option => (
                            <Option key={option.value} value={option.value}>
                              {option.label}
                            </Option>
                          ))}
                        </OptGroup>
                        <OptGroup label="Users">
                          {optionsForDropdown.users?.map(user => (
                            <Option key={user.value} value={user.value}>
                              {user.label}
                            </Option>
                          ))}
                        </OptGroup>
                        </Select>
                        </div>
                        <div style={{marginTop: "1rem"}}>
                          <div className="Criteria-Header">
                                 <Badge style={{ right: "-10px" }} color="#018ee0" count={selectedData?.data?.Criteria?.length}> 
                                  <h5 style={{ margin: "0px" }}>Criteria</h5>
                                  </Badge>
                            <div className="Criteria-Action-btn">
                              <Button disabled={bluePrintData?.lock=="true"} onClick={e=>{setCriteriaModal(true)}} icon={selectedData?.data?.Criteria?.length>0?<FontAwesomeIcon icon={faPen}/>:<FontAwesomeIcon icon={faPlus}/>}></Button>
                              {selectedData?.data?.Criteria?.length>0 && <Button disabled={bluePrintData?.lock=="true"} onClick={e=>{
                                setCriteriaDeleteConfirm("Are you sure, you want to remove Criteria?")
                              }} icon={<FontAwesomeIcon color='red' icon={faTrashAlt}/>}></Button>}
                            </div>
                          </div>
                          <p style={{marginBottom: "10px"}}>
                            Add criteria based on which the transition will be triggered.
                          </p>
                            {/* <Button disabled={bluePrintData?.lock=="true"} onClick={e=>{setCriteriaModal(true)}} icon={<FontAwesomeIcon icon={faPlus}/>}>{view=="edit" && selectedData?.data?.Criteria?.length>0?"Update Criteria":"Add Criteria"}</Button> */}
                          {getCriteriaRows(selectedData?.data?.Criteria)}
                          
                        </div>
                      </TabPane>
                      <TabPane tab="During" key="2">
                      <Radio.Group disabled={bluePrintData?.lock=="true"} onChange={handleRadioChange} value={radioValue}>
                        <div>
                          <Radio value="fields">
                            <Text strong>Fields and Messages</Text>
                            {getDescriptionPopover()}
                          </Radio>
                          {radioValue === 'fields' && (
                            <>
                              <div style={{ marginTop: '10px' }}>
                                <Text>Configure fields and messages that will be displayed while performing a transition in the Task details page.</Text>
                              </div>
                            </>
                          )}
                        </div>

                        <Divider />

                        {/* <div>
                          <Radio value="extensions">
                            <Text strong>Extensions</Text> 
                            <RightOutlined />
                          </Radio>
                          {radioValue === 'extensions' && (
                            <div style={{ marginTop: '10px'}}>
                            </div>
                          )}
                        </div> */}
                        </Radio.Group>
                      </TabPane>
                      <TabPane tab="After" key="3" disabled={_.isEmpty(editFlow)}>
                        <Text>
                          Configure actions to be automated after a transition
                          is performed.
                        </Text>

                        <div className="Selected-Input-Field-Wrapper" style={{maxHeight:'20rem'}}>
                        <div className='container' sm={12}>
                          {/* <Button type="link" icon={<PlusOutlined />} iconPosition='end' style={{ fontSize: "15px" }}
                           onClick={e=>{
                             
                            setEditTemplate(true)}}>
                            Email Alerts
                          </Button> */}
                          {<EmailTemplates flowId={editFlow?.ROWID} editTemplate={true} selectedEdgeData={selectedData?.data} editFlow={editFlow} isBlueprintLocked={bluePrintData?.lock=="true"}/>}
                           </div>
                           {/* {getEmailTemplates()} */}
                          {/* <Button type="link" icon={<PlusOutlined />} iconPosition='end' style={{ fontSize: "15px" }}>
                            Field Update
                          </Button>
                          <Button type="link" icon={<PlusOutlined />} iconPosition='end' style={{ fontSize: "15px" }}>
                            Custom Function
                          </Button>
                          <Button type="link" icon={<PlusOutlined />} iconPosition='end' style={{ fontSize: "15px" }}>
                            Webhooks
                          </Button> */}
                        </div>
                        <div style={{marginTop:'1em'}}>
                        <h5 style={{marginLeft:'7px'}}>  Field Update :</h5>
                            <AfterFieldUpdate flowId={editFlow?.ROWID} selectedEdgeData={selectedData?.data} isBlueprintLocked={bluePrintData?.lock=="true"}/>
                        </div>
                      </TabPane>
                    </Tabs>}
                    </div>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row className="Input-Group">
                <Col>
  <span className="labeltext">
    <Label>Name</Label>
  </span>
  <Input
    disabled={bluePrintData?.lock == "true"}
    className="input"
    value={bluePrintData?.name}
    onChange={handleNameChange}  
  />
  {(nameError || error.includes("name")) && (
    <span style={{ color: "red" }}>
      {nameError ? "Name already exists, choose a different name." : "Please fill the required field"}
    </span>
  )}
</Col>

                </Row>
                <Row className="Input-Group">
                  <Col>
                    <span className="labeltext">
                      <Label>Description</Label>
                    </span>
                    <TextArea
                    disabled={bluePrintData?.lock=="true"}
                      value={bluePrintData?.description}
                      style={{
                        padding: "5px 13px",
                        "min-height": "5rem",
                        "max-height": "5rem",
                      }}
                      onChange={(e) => {
                        if (e.currentTarget.value) {
                          let err = error?.filter((e) => e != "description");
                          setError(err);
                        }
                        e.currentTarget.value = (e.currentTarget.value)?.trimStart();
                        let obj = { ...bluePrintData };
                        obj["description"] = e.currentTarget.value;
                        setBluePrintData(obj);
                      }}
                    />
                    {error.includes("description") && (
                      <span style={{ color: "red" }}>
                        Please fill the required field
                      </span>
                    )}
                  </Col>
                </Row>
                <Divider />
                <Row className="Input-Group">
                    <h5>Input Fields</h5>
                   <div className="Selected-Input-Field-Wrapper">
                      <div className='container' sm={12} style={bluePrintData?.lock=="true" ? {pointerEvents: "none", opacity: 0.5, cursor: "not-allowed"} : {}}>
                      <InputFields
                            Module="TASKFLOW"
                            cardSize={3}
                            selectInputField={selectInputField}
                            setSelectInputField={setSelectInputField}
                            onAdd={(obj,type) => {
                              if(!obj.Name){
                                setErrorPopConfirm("Add Name for the Input Field.");
                                return
                              }
                              let arr = [];
                              if (Array.isArray(bluePrintData?.inputFields) && bluePrintData?.inputFields?.length > 0) {
                                arr = [...bluePrintData?.inputFields];
                              }
                              if(type && type=="edit"){
                                arr=arr.map(k=>{
                                  if(k.id==obj.id){
                                    return obj;
                                  }else{
                                    return k;
                                  }
                                })
                              }else{
                                arr.push(obj);
                              }
                              setBluePrintData({ ...bluePrintData, inputFields: arr });
                            }}
                          ><div className='Card Add-Icon'>
                              <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faPlus} />
                              {"Add"}
                            </div>
                          </InputFields>
                          {bluePrintData?.inputFields && bluePrintData?.inputFields.map(field => {
                              return <div className='Card'>
                                <div style={{
                                  display: "flex",
                                  "align-items": "center",
                                }} onClick={e => {
                                  setSelectInputField({
                                    type: "edit",
                                    data: field
                                  })
                                }}>
                                    {InputFieldIcon?.find(i=>i.value==field.Type)?.icon}
                                    {/* {field.Type == "PICKLIST" ? <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faList} />
                                        : <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faKeyboard} />} */}
                                    {field.Name}
                                  </div>
                                  <FontAwesomeIcon className='Close-Icon' style={{ "margin-right": "7px" }} icon={faTimes} onClick={e=>{
                                  if (field?.Type == "ATTACHMENT") {
                                    getPopupIfRequired(field);
                                  } else {
                                    let temp = { ...bluePrintData };
                                    temp["inputFields"] = temp?.inputFields?.filter(c => c.id != field.id);
                                    if (criteriaFieldGroups["Input Fields"]?.length > 0) {
                                      let tempCriteria = criteriaFieldGroups["Input Fields"]?.filter(k => k.id != field.id);
                                      setCriteriaFieldGroups({ ...criteriaFieldGroups, "Input Fields": tempCriteria });
                                    }
                                    setBluePrintData(temp);
                                  }
                                  }} />
                              </div>
                          })}
                          
                          {/* <div className='Card Add-Icon'>
                              <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faPlus} />
                              {"Add"}
                          </div> */}
                      </div>
                    </div> 
                    <Divider />
                </Row>
                {/* <Divider /> */}
                <Row className="Input-Group">
                    <h5>Access Control</h5>
                   <div className="Selected-Input-Field-Wrapper">
                      <div className='container' style={bluePrintData?.lock=="true" ? {pointerEvents: "none", opacity: 0.5, cursor: "not-allowed"} : {}} sm={12}>
                       <AccessControl FlowID={editFlow?.ROWID}/>  
                      </div>
                    </div> 
                    <Divider />
                </Row>
                {/* <Row style={{"max-height":"25%"}} className='Input-Group'>
                <h5>Email Templates</h5>
                <div className="Selected-Input-Field-Wrapper">
                      <div className='container' sm={12}>
                            <EmailTemplates flowId={editFlow?.ROWID} selectedEdgeData={selectedData?.data}/>
                      </div>
                </div>
                </Row> */}
              </>
            )}
          </Col>
        </Row>
      </div>
    );
}